import * as React from 'react';

type Props = {
  onFilesAdded: (files: FileList) => void,
  more: boolean, // True if we already have some photos,
}
class FileInput extends React.Component<Props> {
  fileFieldRef: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);
    this.fileFieldRef = React.createRef();
  }

  static defaultProps = {
    more: false,
  }

  render() {
    const buttonWording = this.props.more ? "Add more photos" : "Add photos";
     return (
       <div>
         <button 
           className="btn btn-primary btn-lg w-100"
           onClick={
             () => this.fileFieldRef.current?.click()
           }>{buttonWording}</button>

        <input type="file" 
          onChange={ e =>  this.props.onFilesAdded(e.target.files!)}
          name="photo[image]"
          multiple={true}
          className="invisible d-none"
          ref={this.fileFieldRef}
          accept="image/jpeg,image/jpg" />
      </div>
    );
  }
}
export default FileInput;
